import clsx from 'clsx'

interface Props {
  status: string | null | undefined
}

const PALETTE: Record<string, string> = {
  ATIVO:    'bg-emerald-50 text-emerald-700 ring-emerald-200',
  INATIVO:  'bg-slate-100 text-slate-600 ring-slate-200',
  PENDENTE: 'bg-amber-50 text-amber-700 ring-amber-200',
  PAGO:     'bg-emerald-50 text-emerald-700 ring-emerald-200',
  CANCELADO:'bg-rose-50 text-rose-700 ring-rose-200',
  TITULAR:    'bg-blue-50 text-blue-700 ring-blue-200',
  DEPENDENTE: 'bg-violet-50 text-violet-700 ring-violet-200',
}

export function StatusBadge({ status }: Props) {
  const label = (status ?? '—').toString()
  const klass = PALETTE[label] ?? 'bg-slate-50 text-slate-600 ring-slate-200'
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
        klass,
      )}
    >
      {label}
    </span>
  )
}
